export default __webpack_public_path__ + "static/media/scanRound.5fd71450.png";